import { render } from "./SuperAdministrators.vue?vue&type=template&id=b4e6f39a"
import script from "./SuperAdministrators.vue?vue&type=script&lang=js"
export * from "./SuperAdministrators.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__